<template>
  <div class="contact-v2">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>

      <div class="page-wrapper">
        <div class="content container-fluid v2-page">
          <!-- ============================= KEPALA HALAMAN ============================= -->
          <div class="v2-page-head">
            <div class="v2-head-copy">
              <span class="v2-eyebrow">
                <i class="fa fa-address-book-o"></i> Manajemen Kontak
              </span>
              <h3 class="v2-title">Data Kontak</h3>
              <p class="v2-subtitle">
                Terhubung langsung dengan data kontak, grup, dan tagging pada sistem.
              </p>
            </div>

            <div class="v2-head-actions">
              <button
                type="button"
                class="btn v2-btn v2-btn-outline"
                @click="bukaModalImport"
              >
                <i class="fa fa-upload"></i>
                <span>Import Kontak</span>
              </button>

              <router-link
                to="/contacts-sync-v2"
                class="btn v2-btn v2-btn-outline"
              >
                <i class="fa fa-refresh"></i>
                <span>Sinkronisasi Kontak</span>
              </router-link>

              <button
                type="button"
                id="btnAddContact"
                class="btn v2-btn v2-btn-primary"
                @click="bukaModalTambah"
              >
                <i class="fa fa-plus"></i>
                <span>Tambah Kontak</span>
              </button>
            </div>
          </div>

          <div v-if="moveHint" class="v2-move-hint" role="status">
            <span class="v2-move-hint-icon">
              <i class="fa fa-exchange"></i>
            </span>
            <div>
              <strong>Mode pindahkan kontak</strong>
              <p>
                Pilih kontak yang ingin dipindahkan, lalu gunakan
                <b>Masukkan ke Grup</b> pada toolbar aksi massal. Untuk melepas
                dari grup asal, gunakan <b>Keluarkan dari Semua Grup</b>.
              </p>
            </div>
          </div>

          <!-- ============================= RINGKASAN ============================= -->
          <div class="v2-stats">
            <div class="v2-stat">
              <div class="v2-stat-icon">
                <i class="fa fa-users"></i>
              </div>
              <div class="v2-stat-copy">
                <span class="v2-stat-label">Total Kontak</span>
                <strong>{{ totalRecords }}</strong>
              </div>
            </div>

            <div class="v2-stat">
              <div class="v2-stat-icon">
                <i class="fa fa-object-group"></i>
              </div>
              <div class="v2-stat-copy">
                <span class="v2-stat-label">Jumlah Grup</span>
                <strong>{{ totalGrup || groupListArr.length }}</strong>
              </div>
            </div>

            <div class="v2-stat">
              <div class="v2-stat-icon">
                <i class="fa fa-tags"></i>
              </div>
              <div class="v2-stat-copy">
                <span class="v2-stat-label">Tagging Aktif</span>
                <strong>{{ totalTagging || contactOptionsTags.length }}</strong>
              </div>
            </div>
          </div>

          <!-- ============================= FILTER & PENCARIAN ============================= -->
          <div class="v2-card v2-toolbar">
            <div class="v2-toolbar-row">
              <!-- Kata kunci memakai contactListParam.keywords + searchData() dari v1 -->
              <div class="v2-search">
                <i class="fa fa-search v2-search-icon"></i>
                <input
                  v-model="contactListParam.keywords"
                  type="text"
                  autocomplete="off"
                  placeholder="Cari nama atau nomor WhatsApp..."
                  aria-label="Cari nama atau nomor WhatsApp"
                  @keyup.enter="searchData"
                />
                <button
                  v-if="contactListParam.keywords"
                  type="button"
                  class="v2-search-clear"
                  title="Bersihkan kata kunci"
                  @click="contactListParam.keywords = ''; searchData()"
                >
                  <i class="fa fa-times"></i>
                </button>
              </div>

              <button type="button" class="btn v2-btn v2-btn-search" @click="searchData">
                <i class="fa fa-search"></i>
                <span>CARI</span>
              </button>

              <!-- Grup: vue-multiselect yang sudah ada + contact/getGroupList -->
              <div class="v2-select-wrap">
                <multiselect
                  v-model="selectedContact"
                  id="v2-group-filter"
                  label="name"
                  track-by="id"
                  :placeholder="'Pilih Grup'"
                  :multiple="true"
                  open-direction="bottom"
                  :custom-label="customLabel"
                  :options="contactOptions"
                  :searchable="true"
                  :loading="isLoading"
                  :internal-search="false"
                  :close-on-select="false"
                  :options-limit="300"
                  :limit="3"
                  :limit-text="limitText"
                  :max-height="600"
                  :show-no-results="true"
                  :hide-selected="true"
                  :show-labels="false"
                  @search-change="asyncFind"
                >
                  <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span>{{ option.name }}</span>
                      <span class="custom__remove" @click="remove(option)">&#10060;</span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div
                      v-if="selectedContact.length"
                      class="multiselect__clear"
                      @mousedown.prevent.stop="clearAll(props.search)"
                    ></div>
                  </template>
                  <span slot="noResult">Tidak ada hasil ditemukan.</span>
                </multiselect>
              </div>

              <!-- Tagging: vue-multiselect yang sudah ada + contact/getTagList -->
              <div class="v2-select-wrap">
                <multiselect-tags
                  v-model="selectedContactTags"
                  id="v2-tag-filter"
                  label="name"
                  track-by="id"
                  :placeholder="'Pilih Tagging'"
                  :multiple="true"
                  open-direction="bottom"
                  :custom-label="customLabel"
                  :options="contactOptionsTags"
                  :searchable="true"
                  :isLoadingTags="isLoadingTags"
                  :internal-search="false"
                  :close-on-select="false"
                  :options-limit="300"
                  :limit="3"
                  :limit-text="limitText"
                  :max-height="600"
                  :show-no-results="true"
                  :hide-selected="true"
                  :show-labels="false"
                  @search-change="asyncFindTags"
                >
                  <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span>{{ option.name }}</span>
                      <span class="custom__remove" @click="remove(option)">&#10060;</span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div
                      v-if="selectedContactTags.length"
                      class="multiselect__clear"
                      @mousedown.prevent.stop="clearAllTags(props.search)"
                    ></div>
                  </template>
                  <span slot="noResult">Tidak ada hasil ditemukan.</span>
                </multiselect-tags>
              </div>

              <!-- Ekspor memakai exportData() dari v1 -->
              <button type="button" class="btn v2-btn v2-btn-outline" @click="exportData">
                <i class="fa fa-file-excel-o"></i>
                <span>Ekspor Excel</span>
              </button>
            </div>
          </div>

          <!-- ============================= TABEL ============================= -->
          <div class="v2-card v2-table-card">
            <div class="table-responsive">
              <table class="table v2-table mb-0">
                <thead>
                  <tr>
                    <th class="v2-check-col">
                      <input
                        v-model="selectAllTable"
                        type="checkbox"
                        :disabled="loading || !contactListArr.length"
                        title="Pilih semua kontak"
                        aria-label="Pilih semua kontak"
                      />
                    </th>
                    <th>Nama Kontak</th>
                    <th>No. WhatsApp</th>
                    <th>Grup</th>
                    <th>Tagging</th>
                    <th>Ulang Tahun</th>
                    <th class="text-right">Aksi</th>
                  </tr>
                </thead>

                <tbody>
                  <!-- Kerangka pemuatan -->
                  <template v-if="loading">
                    <tr v-for="n in 6" :key="'skeleton-' + n">
                      <td class="v2-check-col">
                        <span class="v2-sk v2-sk-check"></span>
                      </td>
                      <td>
                        <div class="v2-sk-person">
                          <span class="v2-sk v2-sk-avatar"></span>
                          <span class="v2-sk v2-sk-line" style="width: 130px;"></span>
                        </div>
                      </td>
                      <td><span class="v2-sk v2-sk-line" style="width: 120px;"></span></td>
                      <td><span class="v2-sk v2-sk-badge"></span></td>
                      <td><span class="v2-sk v2-sk-badge"></span></td>
                      <td><span class="v2-sk v2-sk-line" style="width: 100px;"></span></td>
                      <td>
                        <span class="v2-sk v2-sk-line" style="width: 58px; margin-left: auto;"></span>
                      </td>
                    </tr>
                  </template>

                  <!-- Data dari contact/getContactList -->
                  <template v-else-if="rows.length">
                    <tr
                      v-for="row in rows"
                      :key="row.id"
                      :class="{ 'v2-row-selected': selectedCheckbox.indexOf(row) !== -1 }"
                    >
                      <td class="v2-check-col">
                        <input
                          v-model="selectedCheckbox"
                          type="checkbox"
                          :value="row"
                          :aria-label="'Pilih ' + fullName(row)"
                        />
                      </td>

                      <td>
                        <div class="v2-person">
                          <div class="v2-avatar">{{ initials(row) }}</div>
                          <div class="v2-person-info">
                            <span class="v2-person-name">{{ fullName(row) }}</span>
                            <span class="v2-person-meta">
                              {{ row.email || "ID #" + row.id }}
                            </span>
                          </div>
                        </div>
                      </td>

                      <td>
                        <template v-if="row.is_group == 1">
                          <span class="v2-wa v2-wa-group">
                            <i class="fa fa-users"></i>
                            {{ row.phone_number_group || "-" }}
                            <template v-if="row.provider">
                              (grup {{ row.provider }})
                            </template>
                          </span>
                        </template>
                        <template v-else-if="row.phone_number != 0">
                          <a
                            :href="'https://wa.me/' + row.phone_number"
                            target="_blank"
                            rel="noopener noreferrer"
                            class="v2-wa"
                            :title="'Buka obrolan ' + fullName(row) + ' di WhatsApp'"
                          >
                            <i class="fa fa-whatsapp"></i>
                            {{ row.phone_number }}
                          </a>
                        </template>
                        <span v-else class="v2-muted">{{ row.phone_number }}</span>
                      </td>

                      <!-- Label grup dari contact/viewContact + contact/getGroupList -->
                      <td>
                        <div v-if="row.is_group == 1" class="v2-badges">
                          <span class="v2-badge v2-badge-grup">
                            <i class="fa fa-users"></i> Grup WhatsApp
                          </span>
                        </div>
                        <span
                          v-else-if="memuatRelasi && grupBaris[row.id] === undefined"
                          class="v2-sk v2-sk-badge"
                        ></span>
                        <div
                          v-else-if="(grupBaris[row.id] || []).length"
                          class="v2-badges"
                        >
                          <span
                            v-for="grup in grupBaris[row.id]"
                            :key="'grup-' + row.id + '-' + grup.id"
                            class="v2-badge v2-badge-grup"
                          >
                            <i class="fa fa-users"></i>
                            {{ grup.name }}
                          </span>
                        </div>
                        <span v-else class="v2-muted">Tanpa Grup</span>
                      </td>

                      <!-- Label tagging dari crm/getTagDetailByContactId -->
                      <td>
                        <span
                          v-if="row.is_group == 1"
                          class="v2-muted"
                        >&mdash;</span>
                        <span
                          v-else-if="memuatRelasi && tagBaris[row.id] === undefined"
                          class="v2-sk v2-sk-badge"
                        ></span>
                        <div
                          v-else-if="(tagBaris[row.id] || []).length"
                          class="v2-badges"
                        >
                          <span
                            v-for="tag in tagBaris[row.id]"
                            :key="'tag-' + row.id + '-' + tag.id"
                            class="v2-badge v2-badge-tag"
                            :class="'v2-tag-' + badgeIndex(tag.id)"
                          >
                            #{{ tag.name }}
                          </span>
                        </div>
                        <span v-else class="v2-muted">Belum ada tagging</span>
                      </td>

                      <td>
                        <span v-if="row.birth_date_is_filled == 1" class="v2-date">
                          <i class="fa fa-birthday-cake"></i>
                          {{ formatFromUnixToDate(row.birth_date_data) }}
                        </span>
                        <span v-else class="v2-muted">&mdash;</span>
                      </td>

                      <td>
                        <div v-if="row.is_group != 1" class="v2-actions">
                          <button
                            type="button"
                            class="v2-icon-btn v2-icon-edit"
                            title="Ubah kontak"
                            @click="bukaModalEdit(row)"
                          >
                            <i class="fa fa-pencil"></i>
                          </button>
                          <button
                            type="button"
                            class="v2-icon-btn v2-icon-delete"
                            title="Hapus kontak"
                            @click="deleteSingleContact(row)"
                          >
                            <i class="fa fa-trash"></i>
                          </button>
                        </div>
                        <span v-else class="v2-muted">&mdash;</span>
                      </td>
                    </tr>
                  </template>

                  <!-- Kondisi kosong -->
                  <template v-else>
                    <tr>
                      <td colspan="7">
                        <div class="v2-empty">
                          <div class="v2-empty-icon">
                            <i class="fa fa-user-plus"></i>
                          </div>
                          <h5>Belum ada data kontak yang ditemukan.</h5>
                          <p>
                            Silakan ubah kata kunci atau filter, atau tambahkan kontak
                            baru terlebih dahulu.
                          </p>
                          <button
                            type="button"
                            class="btn v2-btn v2-btn-primary"
                            @click="bukaModalTambah"
                          >
                            <i class="fa fa-plus"></i> Tambah Kontak
                          </button>
                        </div>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>

            <!-- Paginasi memakai onPageChange/onNextChange/onPrevChange/onPerPageChange dari v1 -->
            <div v-if="!loading && totalRecords > 0" class="v2-table-footer">
              <div class="v2-footer-left">
                <span>Baris per halaman</span>
                <select
                  v-model.number="contactListParam.perPage"
                  class="v2-select"
                  aria-label="Jumlah baris per halaman"
                  @change="onPerPageChange(contactListParam.perPage)"
                >
                  <option :value="10">10</option>
                  <option :value="20">20</option>
                  <option :value="25">25</option>
                  <option :value="30">30</option>
                  <option :value="40">40</option>
                  <option :value="50">50</option>
                </select>
                <span class="v2-footer-divider"></span>
                <span>
                  {{ rangeStart }}&ndash;{{ rangeEnd }} dari {{ totalRecords }} kontak
                </span>
              </div>

              <div class="v2-pager">
                <button
                  type="button"
                  :disabled="currentPage <= 1"
                  @click="onPrevChange(parseInt(currentPage))"
                >
                  <i class="fa fa-angle-left"></i>
                  <span>Sebelumnya</span>
                </button>

                <template v-for="(pageItem, index) in pageNumbers">
                  <span
                    v-if="pageItem === '...'"
                    :key="'ellipsis-' + index"
                    class="v2-pager-ellipsis"
                  >
                    &hellip;
                  </span>
                  <button
                    v-else
                    :key="'page-' + pageItem"
                    type="button"
                    :class="{ active: pageItem === currentPage }"
                    @click="onPageChange(pageItem)"
                  >
                    {{ pageItem }}
                  </button>
                </template>

                <button
                  type="button"
                  :disabled="currentPage >= totalPages"
                  @click="onNextChange(parseInt(currentPage))"
                >
                  <span>Selanjutnya</span>
                  <i class="fa fa-angle-right"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- ============================= AKSI MASSAL (METODE V1) ============================= -->
    <transition name="v2-slide-up">
      <div v-if="selectedCheckbox.length" class="v2-bulk-bar">
        <div class="v2-bulk-count">
          <span class="v2-pill">{{ selectedCheckbox.length }}</span>
          <span>Kontak Dipilih</span>
        </div>

        <span class="v2-bulk-sep"></span>

        <div class="btn-group dropup v2-bulk-group">
          <button
            type="button"
            class="v2-bulk-btn dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          >
            <i class="fa fa-users"></i>
            <span>Tetapkan Grup</span>
            <i class="fa fa-angle-up"></i>
          </button>
          <div class="dropdown-menu dropdown-menu-left">
            <a
              href="javascript:void(0)"
              class="dropdown-item"
              data-toggle="modal"
              data-target="#edit_group"
              @click="actShowHideUpdateGroup"
            >
              <i class="fa fa-users"></i> Masukkan ke Grup
            </a>
            <a
              href="javascript:void(0)"
              class="dropdown-item"
              @click.prevent="keluarkanDariSemuaGrup"
            >
              <i class="fa fa-eraser"></i> Keluarkan dari Semua Grup
            </a>
          </div>
        </div>

        <button type="button" class="v2-bulk-btn v2-bulk-delete" @click="deleteContactSelected">
          <i class="fa fa-trash"></i>
          <span>Hapus</span>
        </button>

        <button type="button" class="v2-bulk-btn v2-bulk-clear" @click="hideActions">
          <i class="fa fa-times"></i>
          <span>Bersihkan Pilihan</span>
        </button>
      </div>
    </transition>

    <!-- ============================= MODAL KONTAK V2 ============================= -->
    <contact-form-modal-v2
      :visible="showContactModal"
      :mode="contactModalMode"
      :contact-id="contactModalId"
      @close="tutupModalKontak"
      @saved="handleKontakTersimpan"
    />

    <contact-import-modal-v2
      :visible="showImportModal"
      @close="tutupModalImport"
      @success="handleImportSelesai"
    />

    <!-- ============================= KOMPONEN GRUP YANG SUDAH ADA ============================= -->
    <create-group :getGroupList="getGroupList" />

    <update-group
      :filterContactListGroup="filterContactListGroup"
      :showUpdateGroup="showUpdateGroup"
      :selectedCheckbox="selectedCheckbox"
    />
  </div>
</template>

<script>
import $ from "jquery";
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import ContactFormModalV2 from "./ContactFormModalV2.vue";
import ContactImportModalV2 from "./ContactImportModalV2.vue";
import UpdateGroup from "./updateGroup.vue";
import CreateGroup from "./createGroup.vue";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");
import MultiselectTags from "vue-multiselect";

import { formatFromUnixToDate } from "@/utils/helper";

export default {
  name: "ContactListV2",

  components: {
    LayoutHeader,
    LayoutSidebar,
    Multiselect,
    MultiselectTags,
    ContactFormModalV2,
    ContactImportModalV2,
    UpdateGroup,
    CreateGroup
  },

  data() {
    return {
      // Parameter yang sama dengan halaman /contacts (v1)
      contactListParam: {
        keywords: "",
        phone_number: "",
        email: "",
        name: "",
        group_id: [],
        tag_id: [],
        page: 0,
        perPage: 10,
        rendered: 0,
        totalRecords: 0
      },

      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,

      loading: false,
      loadingMessage: true,
      loadingGroup: false,

      // Filter grup (vue-multiselect v1)
      selectedContact: [],
      contactOptions: [],
      isLoading: false,
      groupListParam: {
        name: "",
        page: 0,
        perPage: 10
      },

      // Filter tagging (vue-multiselect v1)
      selectedContactTags: [],
      contactOptionsTags: [],
      isLoadingTags: false,
      tagListParam: {
        tag_id: null,
        name: "",
        page: 0,
        perPage: 10
      },

      // Data referensi untuk badge grup dan ringkasan halaman
      daftarGrup: [],
      grupLookup: {},
      totalGrup: 0,
      totalTagging: 0,

      // Relasi grup dan tagging per baris, diambil dari API detail yang sudah ada
      grupBaris: {},
      tagBaris: {},
      memuatRelasi: false,
      relasiRequestId: 0,

      // Pilihan massal (array baris, sama seperti v1)
      selectedCheckbox: [],

      // Modal kontak v2
      showContactModal: false,
      contactModalMode: "create",
      contactModalId: "",

      // Modal import v2
      showImportModal: false,
      importRefreshTimer: null,

      // Modal grup yang sudah ada di v1
      showUpdateGroup: "",
      moveHint: false
    };
  },

  computed: {
    contactListArr() {
      return this.$store.state.contact.contactListArr;
    },

    groupListArr() {
      return this.$store.state.contact.groupListArr;
    },

    selectAllTable: {
      get() {
        return this.contactListArr
          ? this.selectedCheckbox.length == this.contactListArr.length
          : false;
      },
      set(value) {
        const selectedCheckbox = [];

        if (value) {
          this.contactListArr.forEach(function(row) {
            selectedCheckbox.push(row);
          });
        }

        this.selectedCheckbox = selectedCheckbox;
      }
    },

    totalPages() {
      return Math.max(1, Math.ceil(this.totalRecords / this.contactListParam.perPage));
    },

    rangeStart() {
      return this.totalRecords
        ? (this.currentPage - 1) * this.contactListParam.perPage + 1
        : 0;
    },

    rangeEnd() {
      return Math.min(
        this.currentPage * this.contactListParam.perPage,
        this.totalRecords
      );
    },

    pageNumbers() {
      const total = this.totalPages;
      const current = this.currentPage;
      const pages = [];

      if (total <= 7) {
        for (let i = 1; i <= total; i += 1) {
          pages.push(i);
        }
        return pages;
      }

      pages.push(1);

      let start = Math.max(2, current - 1);
      let end = Math.min(total - 1, current + 1);

      if (current <= 3) {
        start = 2;
        end = 4;
      }

      if (current >= total - 2) {
        start = total - 3;
        end = total - 1;
      }

      if (start > 2) {
        pages.push("...");
      }

      for (let page = start; page <= end; page += 1) {
        pages.push(page);
      }

      if (end < total - 1) {
        pages.push("...");
      }

      pages.push(total);
      return pages;
    }
  },

  async created() {
    const { filter, tag_id, group_id, group_name, action } = this.$route.query;
    this.moveHint = action === "move";

    const rawGroupId = Array.isArray(group_id) ? group_id[0] : group_id;
    const rawGroupName = Array.isArray(group_name) ? group_name[0] : group_name;
    const filterGroupId =
      rawGroupId === undefined || rawGroupId === null
        ? ""
        : String(rawGroupId).trim();

    if (filter && tag_id) {
      this.selectedContactTags.push({ id: tag_id, name: tag_id });
      this.contactListParam.tag_id = this.selectedContactTags;
    }

    // Alur inisialisasi sama dengan /contacts v1
    this.loading = true;
    this.changeContactListArr([]);
    await this.muatReferensiGrup();

    if (filter && filterGroupId) {
      // group_id adalah identitas utama. group_name hanya fallback label.
      // Jangan pernah mengganti pilihan dengan seluruh daftar grup.
      const matchedGroup = (this.daftarGrup || []).find(
        group => String(group.id) === filterGroupId
      );
      const selectedGroup = matchedGroup
        ? Object.assign({}, matchedGroup, {
            name: matchedGroup.name || rawGroupName || filterGroupId
          })
        : {
            id: rawGroupId,
            name: rawGroupName || filterGroupId
          };

      this.selectedContact = [selectedGroup];
      this.contactListParam.group_id = [selectedGroup];
    }

    this.asyncFind("");
    this.asyncFindTags("");
    this.loadItems();
    this.currentPage = 1;

    if (tag_id) {
      const param = Object.assign({}, this.tagListParam, { id: tag_id });
      this.$store.dispatch("contact/getTagList", param).then(res => {
        if (res.data.data.length > 0) {
          this.selectedContactTags = res.data.data;
          this.contactListParam.tag_id = this.selectedContactTags;
        }
      });
    }
  },

  watch: {
    selectedContact: {
      handler: function(val, oldVal) {
        if (val != oldVal) {
          if (val.length > 0) {
            this.contactListParam.group_id = [];
            val.forEach(group => {
              this.contactListParam.group_id.push(group);
            });
          } else {
            this.contactListParam.group_id = [];
          }
        }
      },
      deep: true
    },

    selectedContactTags: {
      handler: function(val, oldVal) {
        if (val != oldVal) {
          if (val.length > 0) {
            this.contactListParam.tag_id = [];
            val.forEach(tag => {
              this.contactListParam.tag_id.push(tag);
            });
          } else {
            this.contactListParam.tag_id = [];
          }
        }
      },
      deep: true
    }
  },

  methods: {
    formatFromUnixToDate(unixBirthDate) {
      return formatFromUnixToDate(unixBirthDate);
    },

    /* ============================= TABEL / PENCARIAN ============================= */

    async searchData() {
      this.currentPage = 1;
      this.rows = [];
      this.loading = true;
      this.totalRecords = 0;

      const params = { page: 1 };
      this.updateParams(params);
      await this.loadItems();
      this.loading = false;
    },

    async loadItems() {
      this.loading = true;
      this.memuatRelasi = false;
      this.grupBaris = {};
      this.tagBaris = {};
      this.relasiRequestId += 1;
      const relasiRequestId = this.relasiRequestId;

      // Transformasi halaman menjadi offset persis seperti v1
      this.contactListParam.page =
        this.contactListParam.page - 1 <= 0
          ? 0
          : (this.contactListParam.page - 1) * this.contactListParam.perPage;

      await this.$store
        .dispatch("contact/getContactList", this.contactListParam)
        .then(async response => {
          const data = response;

          this.totalRecords = data.totalRecords || 0;
          this.rowPage = data.page;
          this.rows = data.data || [];
          this.loading = false;

          if (this.rows.length > 0) {
            this.contactListArr.push(...this.rows);
            this.changeContactListArr(this.contactListArr);

            // recordsFiltered dipakai v1 untuk menghitung offset berikutnya.
            const recordsFiltered =
              Number(response.recordsFiltered) || this.rows.length;

            this.contactListParam.rendered =
              this.contactListParam.page + recordsFiltered;
            this.contactListParam.page += recordsFiltered;

            if (response.totalRecords > 0) {
              this.contactListParam.totalRecords = response.totalRecords;
            }

            this.loadingMessage = false;

            // Muat relasi Grup dan Tagging per baris dari API yang sudah ada.
            await this.muatRelasiBaris(this.rows, relasiRequestId);
          }
        })
        .catch(error => {
          console.log(error);
          this.loading = false;
          this.loadingMessage = false;
          this.memuatRelasi = false;

          this.$fire({
            title: "Gagal Memuat Data",
            text:
              "Gagal memuat data kontak. Silakan muat ulang halaman atau coba beberapa saat lagi.",
            type: "error",
            timer: 3500
          });
        });
    },

    updateParams(newProps) {
      this.contactListParam = Object.assign({}, this.contactListParam, newProps);
    },

    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },

    async onNextChange(page) {
      if (page + 1 <= Math.ceil(this.totalRecords / this.contactListParam.perPage)) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },

    async onPrevChange(page) {
      if (this.currentPage == 1) {
        return;
      }

      if (page - 1 <= Math.ceil(this.totalRecords / this.contactListParam.perPage)) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },

    async onPerPageChange() {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.contactListParam.perPage
      });
      await this.loadItems();
    },

    /* ============================= API FILTER GRUP & TAGGING ============================= */

    limitText(count) {
      return `dan ${count} lainnya`;
    },

    customLabel({ name }) {
      return `${name}`;
    },

    asyncFind(query) {
      this.isLoading = true;
      this.groupListParam.name = query;

      this.$store
        .dispatch("contact/getGroupList", this.groupListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data || [];
        })
        .catch(() => {
          this.isLoading = false;
        });
    },

    asyncFindTags(query) {
      this.isLoadingTags = true;
      this.tagListParam.name = query;

      this.$store
        .dispatch("contact/getTagList", this.tagListParam)
        .then(response => {
          this.isLoadingTags = false;
          const payload = response.data || {};
          this.contactOptionsTags = payload.data || [];

          // Total tagging diambil dari respons API saat pemuatan awal.
          if (!query) {
            this.totalTagging =
              Number(payload.totalRecords) || this.contactOptionsTags.length;
          }
        })
        .catch(() => {
          this.isLoadingTags = false;
        });
    },

    clearAll() {
      this.selectedContact = [];
    },

    clearAllTags() {
      this.selectedContactTags = [];
    },

    async getGroupList() {
      this.loadingGroup = false;

      await this.$store
        .dispatch("contact/getGroupList", this.groupListParam)
        .catch(error => {
          this.loadingGroup = false;
          console.log("galat", error);
        });
    },

    /**
     * Memuat seluruh grup untuk kebutuhan badge dan ringkasan.
     * Tetap memakai endpoint yang sudah ada, yaitu contact/getGroupList.
     */
    async muatReferensiGrup() {
      try {
        const response = await this.$store.dispatch("contact/getGroupList", {
          name: "",
          page: 0,
          perPage: 1000
        });

        const daftar = (response && response.data) || [];
        const lookup = {};

        daftar.forEach(grup => {
          lookup[grup.id] = grup;
        });

        this.daftarGrup = daftar;
        this.grupLookup = lookup;
        this.totalGrup = Number(response && response.totalRecords) || daftar.length;
      } catch (error) {
        console.log(error);
      }
    },

    /**
     * Mengambil relasi Grup dan Tagging tiap baris.
     * Endpoint yang sudah ada:
     * - contact/viewContact (contact_rel berisi id grup)
     * - crm/getTagDetailByContactId (daftar tag kontak)
     */
    async muatRelasiBaris(rows, requestId) {
      const daftar = rows.filter(row => row.is_group != 1);

      if (!daftar.length) {
        this.memuatRelasi = false;
        return;
      }

      this.memuatRelasi = true;

      const grupBaru = {};
      const tagBaru = {};

      await Promise.all(
        daftar.map(row => {
          const muatGrup = this.$store
            .dispatch("contact/viewContact", row.id)
            .then(response => {
              const relasi = (response && response.contact_rel) || [];
              grupBaru[row.id] = relasi.map(idGrup => {
                return this.grupLookup[idGrup] || { id: idGrup, name: "Grup" };
              });
            })
            .catch(() => {
              grupBaru[row.id] = [];
            });

          const muatTag = this.$store
            .dispatch("crm/getTagDetailByContactId", { contact_id: row.id })
            .then(response => {
              tagBaru[row.id] = Array.isArray(response.data) ? response.data : [];
            })
            .catch(() => {
              tagBaru[row.id] = [];
            });

          return Promise.all([muatGrup, muatTag]);
        })
      );

      // Abaikan hasil lama jika pengguna sudah berpindah halaman.
      if (requestId !== this.relasiRequestId) {
        return;
      }

      this.grupBaris = grupBaru;
      this.tagBaris = tagBaru;
      this.memuatRelasi = false;
    },

    /* ============================= EKSPOR ============================= */

    exportData() {
      // Endpoint dan aksi sama dengan v1: contact/exportData
      const newParam = Object.assign({}, this.contactListParam, {
        page: 0,
        perPage: 0
      });

      this.$store.dispatch("contact/exportData", newParam).then(() => {
        this.$fire({
          title: "Menyiapkan Berkas",
          text:
            "Berkas ekspor sedang disiapkan. Silakan tunggu beberapa saat.",
          type: "warning",
          timer: 3000
        });
      });
    },

    /* ============================= AKSI MASSAL ============================= */

    /**
     * Mengeluarkan kontak terpilih dari grup yang sedang difilter.
     * Memakai aksi yang sudah ada, yaitu contact/unassignContactSelected.
     */
    unassignContactSelected() {
      if (this.selectedCheckbox.length == 0) {
        this.$fire({
          title: "Peringatan",
          text: "Silakan pilih satu atau lebih kontak yang akan dikeluarkan dari grup.",
          type: "warning",
          timer: 3000
        });
        return;
      } else if (this.contactListParam.group_id.length < 1) {
        this.$fire({
          title: "Peringatan",
          text: "Silakan pilih grup terlebih dahulu.",
          type: "warning",
          timer: 3000
        });
        return;
      }

      this.$fire({
        title: "Konfirmasi",
        text: "Apakah Anda yakin ingin mengeluarkan kontak terpilih dari grup ini?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Ya",
        denyButtonText: "Batal"
      }).then(async r => {
        if (r.value == true) {
          const grupTerpilih = this.contactListParam.group_id[0];
          const idGrup = grupTerpilih && grupTerpilih.id ? grupTerpilih.id : grupTerpilih;
          const idKontak = this.selectedCheckbox.map(kontak => kontak.id);

          this.$store
            .dispatch("contact/unassignContactSelected", {
              id: idKontak,
              group_id: idGrup
            })
            .then(() => {
              this.$fire({
                title: "Berhasil",
                text: "Kontak terpilih berhasil dikeluarkan dari grup.",
                type: "success",
                timer: 3000
              }).then(() => {
                this.filterContactListGroup(idGrup);
                this.getGroupList();
                this.selectedCheckbox = [];
                this.searchData();
              });
            });
        }
      });
    },

    /**
     * Mengeluarkan kontak terpilih dari seluruh grup.
     * Memakai endpoint yang sudah ada, yaitu contact/unassignContactSelected, untuk setiap grup.
     */
    keluarkanDariSemuaGrup() {
      if (this.selectedCheckbox.length == 0) {
        this.$fire({
          title: "Peringatan",
          text: "Silakan pilih satu atau lebih kontak yang akan dikeluarkan dari grup.",
          type: "warning",
          timer: 3000
        });
        return;
      }

      const daftarIdGrup = this.daftarGrup.map(grup => grup.id);

      if (!daftarIdGrup.length) {
        this.$fire({
          title: "Peringatan",
          text: "Data grup belum tersedia. Silakan muat ulang halaman.",
          type: "warning",
          timer: 3000
        });
        return;
      }

      this.$fire({
        title: "Konfirmasi",
        text:
          "Apakah Anda yakin ingin mengeluarkan " +
          this.selectedCheckbox.length +
          " kontak terpilih dari semua grup?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Ya",
        denyButtonText: "Batal"
      }).then(r => {
        if (r.value != true) {
          return;
        }

        const idKontak = this.selectedCheckbox.map(kontak => kontak.id);

        Promise.all(
          daftarIdGrup.map(idGrup => {
            return this.$store.dispatch("contact/unassignContactSelected", {
              id: idKontak,
              group_id: idGrup
            });
          })
        )
          .then(() => {
            this.$fire({
              title: "Berhasil",
              text:
                "Kontak terpilih berhasil dikeluarkan dari semua grup.",
              type: "success",
              timer: 3000
            }).then(() => {
              this.selectedCheckbox = [];
              this.searchData();
              this.getGroupList();
            });
          })
          .catch(error => {
            console.log(error);
            this.$fire({
              title: "Gagal",
              text:
                "Gagal mengeluarkan kontak dari grup. Silakan coba beberapa saat lagi.",
              type: "error",
              timer: 3500
            });
          });
      });
    },

    deleteContactSelected() {
      if (this.selectedCheckbox.length == 0) {
        this.$fire({
          title: "Peringatan",
          text: "Silakan pilih minimal satu kontak yang akan dihapus.",
          type: "warning",
          timer: 3000
        });
        return;
      }

      this.$fire({
        title: "Konfirmasi Hapus",
        text:
          "Apakah Anda yakin ingin menghapus " +
          this.selectedCheckbox.length +
          " kontak yang dipilih?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: "Ya",
        denyButtonText: "Batal"
      }).then(async r => {
        if (r.value == true) {
          const formDeleteSelected = {
            id: this.selectedCheckbox
          };

          this.$store
            .dispatch("contact/deleteContactSelected", formDeleteSelected)
            .then(() => {
              this.$fire({
                title: "Berhasil",
                text: "Kontak yang dipilih berhasil dihapus.",
                type: "success",
                timer: 3000
              }).then(() => {
                this.filterContactListByName();
                this.selectedCheckbox = [];
              });
            });
        }
      });
    },

    deleteSingleContact(row) {
      // Tetap memakai deleteContactSelected (endpoint dan alur v1)
      this.selectedCheckbox = [row];
      this.deleteContactSelected();
    },

    hideActions() {
      this.selectAllTable = false;
      this.selectedCheckbox = [];
    },

    /* ============================= MODAL KONTAK V2 ============================= */

    bukaModalTambah() {
      this.contactModalMode = "create";
      this.contactModalId = "";
      this.showContactModal = true;
    },

    bukaModalEdit(row) {
      if (!row || !row.id || row.is_group == 1) {
        return;
      }

      this.contactModalMode = "edit";
      this.contactModalId = row.id;
      this.showContactModal = true;
    },

    tutupModalKontak() {
      this.showContactModal = false;
    },

    handleKontakTersimpan(payload) {
      this.showContactModal = false;
      this.hideActions();
      this.searchData();

      if (payload && payload.warning) {
        this.$fire({
          title: "Perhatian",
          text: payload.warning,
          type: "warning",
          timer: 3500
        });
        return;
      }

      const pesan =
        payload && payload.mode === "edit"
          ? "Perubahan kontak berhasil disimpan."
          : "Kontak berhasil ditambahkan.";

      this.$fire({
        title: "Berhasil",
        text: pesan,
        type: "success",
        timer: 3000
      });
    },

    /* ============================= MODAL IMPORT V2 ============================= */

    bukaModalImport() {
      this.showImportModal = true;
    },

    tutupModalImport() {
      this.showImportModal = false;
    },

    handleImportSelesai(payload) {
      this.showImportModal = false;
      this.hideActions();
      this.searchData();

      if (this.importRefreshTimer) {
        clearTimeout(this.importRefreshTimer);
      }

      // Proses import berjalan di latar belakang; muat ulang sekali lagi setelah jeda.
      this.importRefreshTimer = setTimeout(() => {
        this.searchData();
      }, 5000);

      const peringatan = payload && payload.warning ? payload.warning : "";
      const pesanUtama =
        payload && payload.message
          ? payload.message
          : "Selamat! File kontak berhasil diunggah dan sedang ditambahkan ke daftar Anda.";

      this.$fire({
        title: peringatan ? "Import Berhasil dengan Catatan" : "Import Berhasil",
        text: peringatan ? pesanUtama + " " + peringatan : pesanUtama,
        type: peringatan ? "warning" : "success",
        timer: peringatan ? 6000 : 4000
      });
    },

    /* ============================= MODAL GRUP ============================= */

    actShowHideUpdateGroup() {
      this.showUpdateGroup = "1";
    },

    muatUlangSetelahGrup() {
      this.getGroupList();
      this.searchData();
    },

    /* ============================= PEMUATAN ULANG ALUR V1 ============================= */

    async filterContactListByName() {
      this.changeContactListArr([]);

      this.contactListParam.totalRecords = 0;
      this.contactListParam.rendered = 0;
      this.contactListParam.page = 0;
      this.contactListParam.perPage = 20;
      this.contactListParam.group_id = [];
      this.selectedCheckbox = [];

      this.searchData();
    },

    async filterContactListGroup(groupId) {
      // v1 bisa mengirim objek { id, name }; ambil id-nya agar data permintaan tetap valid.
      const id = groupId && groupId.id !== undefined ? groupId.id : groupId;

      this.changeContactListArr([]);

      this.contactListParam.totalRecords = 0;
      this.contactListParam.rendered = 0;
      this.contactListParam.page = 0;
      this.contactListParam.perPage = 10;
      this.contactListParam.group_id = [];

      if (id !== "" && id !== undefined && id !== null) {
        this.contactListParam.group_id.push({ id: id });
      }

      this.selectedCheckbox = [];
    },

    /* ============================= HELPER STORE ============================= */

    getUniqueListBy(arr, key) {
      return [...new Map(arr.map(item => [item[key], item])).values()];
    },

    async changeContactListArr(data) {
      const newArr = this.getUniqueListBy(data, "id");
      await this.$store.dispatch("contact/setContactListArr", newArr);
    },

    /* ============================= HELPER TAMPILAN ============================= */

    fullName(row) {
      return ((row.first_name || "") + " " + (row.last_name || "")).trim() || "Tanpa Nama";
    },

    badgeIndex(id) {
      const teks = String(id || "");
      let nilai = 0;

      for (let i = 0; i < teks.length; i += 1) {
        nilai = (nilai * 31 + teks.charCodeAt(i)) % 100000;
      }

      return nilai % 6;
    },

    initials(row) {
      const name = this.fullName(row);
      const parts = name.split(/\s+/).filter(Boolean);

      if (!parts.length) {
        return "?";
      }

      if (parts.length === 1) {
        return parts[0].slice(0, 2).toUpperCase();
      }

      return (parts[0].charAt(0) + parts[1].charAt(0)).toUpperCase();
    }
  },

  mounted() {
    // Segarkan data setelah modal penetapan grup ditutup.
    $("#edit_group").on("hidden.bs.modal", this.muatUlangSetelahGrup);
  },

  beforeDestroy() {
    $("#edit_group").off("hidden.bs.modal", this.muatUlangSetelahGrup);

    if (this.importRefreshTimer) {
      clearTimeout(this.importRefreshTimer);
    }

    this.$root.$off("getGroupList");
  }
};
</script>

<style scoped>
.contact-v2 {
  color: #1f2a44;
}

.v2-move-hint {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  margin-bottom: 16px;
  padding: 13px 16px;
  color: #8f5600;
  background: #fffaf1;
  border: 1px solid #f6d49b;
  border-radius: 12px;
}

.v2-move-hint-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 34px;
  width: 34px;
  height: 34px;
  color: #b36b00;
  background: #fff1d6;
  border-radius: 9px;
}

.v2-move-hint strong {
  display: block;
  margin-bottom: 2px;
  color: #8f5600;
  font-size: 13px;
}

.v2-move-hint p {
  margin: 0;
  color: #8f5600;
  font-size: 13px;
  line-height: 1.5;
}

.v2-page {
  padding-top: 24px;
  padding-bottom: 120px;
}

/* ============================= KEPALA HALAMAN ============================= */

.v2-page-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 18px;
  margin-bottom: 18px;
}

.v2-eyebrow {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  margin-bottom: 7px;
  color: #f39c12;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.09em;
  text-transform: uppercase;
}

.v2-title {
  margin: 0;
  color: #101828;
  font-size: 26px;
  font-weight: 700;
  letter-spacing: -0.02em;
}

.v2-subtitle {
  margin: 6px 0 0;
  color: #667085;
  font-size: 13px;
}

.v2-head-actions {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
  padding-top: 4px;
}

/* ============================= TOMBOL ============================= */

.v2-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  height: 40px;
  padding: 0 18px;
  border: 1px solid transparent;
  border-radius: 9999px;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  transition: background-color 0.18s ease, border-color 0.18s ease,
    box-shadow 0.18s ease, transform 0.18s ease;
}

.v2-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(243, 156, 18, 0.22);
}

.v2-btn-primary {
  color: #ffffff;
  background-color: #f39c12;
  border-color: #f39c12;
  box-shadow: 0 7px 16px rgba(243, 156, 18, 0.26);
  font-weight: 700;
}

.v2-btn-primary:hover,
.v2-btn-primary:focus {
  color: #ffffff;
  background-color: #e08e0b;
  border-color: #e08e0b;
  box-shadow: 0 9px 20px rgba(224, 142, 11, 0.3);
  transform: translateY(-1px);
}

.v2-btn-outline {
  color: #555555;
  background-color: #ffffff;
  border-color: #d1d5db;
}

.v2-btn-outline:hover,
.v2-btn-outline:focus {
  color: #444444;
  background-color: #f9fafb;
  border-color: #b9bec7;
}

.v2-btn-search {
  color: #b36b00;
  background-color: #fff7e8;
  border-color: #f6d49b;
}

.v2-btn-search:hover,
.v2-btn-search:focus {
  color: #8f5600;
  background-color: #ffefd5;
  border-color: #f39c12;
}

/* ============================= RINGKASAN ============================= */

.v2-stats {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 14px;
  margin-bottom: 16px;
}

.v2-stat {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 15px 16px;
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 14px;
  box-shadow: 0 4px 14px rgba(15, 23, 42, 0.035);
}

.v2-stat-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 42px;
  width: 42px;
  height: 42px;
  color: #f39c12;
  background: #fff7e8;
  border-radius: 12px;
  font-size: 17px;
}

.v2-stat-label {
  display: block;
  margin-bottom: 2px;
  color: #667085;
  font-size: 12px;
  font-weight: 500;
}

.v2-stat-copy strong {
  color: #101828;
  font-size: 21px;
  font-weight: 700;
  line-height: 1;
}

/* ============================= KARTU / BILAH ALAT ============================= */

.v2-card {
  background: #ffffff;
  border: 1px solid #e7edf5;
  border-radius: 14px;
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.04);
}

.v2-toolbar {
  position: relative;
  z-index: 20;
  padding: 14px;
  margin-bottom: 16px;
}

.v2-toolbar-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px;
}

.v2-search {
  position: relative;
  display: flex;
  flex: 1 1 220px;
  align-items: center;
  min-width: 200px;
  height: 40px;
  padding: 0 11px;
  background: #f8fafc;
  border: 1px solid #e2e8f2;
  border-radius: 10px;
  transition: background-color 0.18s ease, border-color 0.18s ease,
    box-shadow 0.18s ease;
}

.v2-search:focus-within {
  background: #ffffff;
  border-color: #f6c26b;
  box-shadow: 0 0 0 3px rgba(243, 156, 18, 0.14);
}

.v2-search-icon {
  color: #98a2b3;
  font-size: 13px;
}

.v2-search input {
  width: 100%;
  height: 100%;
  padding: 0 8px;
  color: #344054;
  background: transparent;
  border: 0;
  outline: none;
  font-size: 13px;
}

.v2-search input::placeholder {
  color: #98a2b3;
}

.v2-search-clear {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  color: #98a2b3;
  background: #eef2f7;
  border: 0;
  border-radius: 50%;
  font-size: 10px;
  cursor: pointer;
}

.v2-search-clear:hover {
  color: #475467;
  background: #e2e8f0;
}

.v2-select-wrap {
  flex: 1 1 220px;
  min-width: 200px;
}

/* ============================= TABEL ============================= */

.v2-table-card {
  position: relative;
  z-index: 1;
  overflow: hidden;
  margin-bottom: 16px;
}

.v2-table {
  min-width: 900px;
  margin-bottom: 0;
}

.v2-table thead th {
  padding: 12px 14px;
  color: #667085;
  background: #f8fafc;
  border-top: 0;
  border-bottom: 1px solid #e9eef6;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  white-space: nowrap;
}

.v2-table tbody td {
  padding: 13px 14px;
  color: #344054;
  border-top: 1px solid #f0f3f8;
  font-size: 13px;
  vertical-align: middle;
}

.v2-table tbody tr:hover {
  background: #fffdf8;
}

.v2-table tbody tr.v2-row-selected {
  background: #fff7e8;
}

.v2-check-col {
  width: 48px;
  padding-right: 0 !important;
  text-align: center;
}

.v2-check-col input {
  width: 15px;
  height: 15px;
  margin: 0;
  accent-color: #f39c12;
  cursor: pointer;
}

.v2-person {
  display: flex;
  align-items: center;
  gap: 10px;
}

.v2-avatar {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 0 0 36px;
  width: 36px;
  height: 36px;
  color: #5f5a52;
  background-color: #f1efe9;
  border: 1px solid #e6e2d8;
  border-radius: 10px;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 0.02em;
}

.v2-person-info {
  min-width: 0;
}

.v2-person-name {
  display: block;
  color: #101828;
  font-size: 13px;
  font-weight: 600;
  line-height: 1.35;
}

.v2-person-meta {
  display: block;
  color: #98a2b3;
  font-size: 10px;
  line-height: 1.35;
}

.v2-wa {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 4px 8px;
  color: #067647;
  background: #ecfdf3;
  border: 1px solid #abefc6;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  text-decoration: none;
  transition: background-color 0.18s ease, color 0.18s ease;
}

.v2-wa:hover,
.v2-wa:focus {
  color: #05603a;
  background: #d1fadf;
  text-decoration: none;
}

.v2-wa-group {
  color: #475467;
  background: #f8fafc;
  border-color: #e2e8f2;
  cursor: default;
}

.v2-wa-group:hover {
  color: #475467;
  background: #f8fafc;
}

.v2-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.v2-badge {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 3px 8px;
  border: 1px solid transparent;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1.5;
  white-space: nowrap;
}

.v2-badge i {
  font-size: 9px;
}

.v2-badge-grup {
  color: #b36b00;
  background: #fff7e8;
  border-color: #f6d49b;
}

.v2-tag-0 {
  color: #7c3aed;
  background: #f5f3ff;
  border-color: #ddd6fe;
}

.v2-tag-1 {
  color: #0e7490;
  background: #ecfeff;
  border-color: #a5f3fc;
}

.v2-tag-2 {
  color: #047857;
  background: #ecfdf5;
  border-color: #a7f3d0;
}

.v2-tag-3 {
  color: #b45309;
  background: #fffbeb;
  border-color: #fde68a;
}

.v2-tag-4 {
  color: #be123c;
  background: #fff1f2;
  border-color: #fecdd3;
}

.v2-tag-5 {
  color: #475467;
  background: #f8fafc;
  border-color: #e2e8f0;
}

.v2-muted {
  color: #98a2b3;
  font-size: 12px;
}

.v2-date {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #475467;
  font-size: 12px;
  white-space: nowrap;
}

.v2-date i {
  color: #f39c12;
}

.v2-actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 6px;
}

.v2-icon-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  padding: 0;
  color: #667085;
  background: #ffffff;
  border: 1px solid #e5eaf2;
  border-radius: 8px;
  font-size: 12px;
  cursor: pointer;
  transition: background-color 0.18s ease, border-color 0.18s ease,
    color 0.18s ease;
}

.v2-icon-edit:hover {
  color: #b36b00;
  background: #fff7e8;
  border-color: #f6d49b;
}

.v2-icon-delete:hover {
  color: #b42318;
  background: #fef3f2;
  border-color: #fecdca;
}

/* ============================= KERANGKA PEMUATAN ============================= */

.v2-sk {
  display: inline-block;
  height: 12px;
  background: linear-gradient(90deg, #eef2f7 25%, #f8fafc 37%, #eef2f7 63%);
  background-size: 400% 100%;
  border-radius: 6px;
  animation: v2-shimmer 1.4s ease infinite;
}

.v2-sk-check {
  width: 15px;
  height: 15px;
  border-radius: 4px;
}

.v2-sk-avatar {
  width: 36px;
  height: 36px;
  border-radius: 10px;
}

.v2-sk-line {
  height: 11px;
}

.v2-sk-badge {
  width: 72px;
  height: 20px;
  border-radius: 20px;
  vertical-align: middle;
}

.v2-sk-person {
  display: flex;
  align-items: center;
  gap: 10px;
}

@keyframes v2-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}

/* ============================= KONDISI KOSONG ============================= */

.v2-empty {
  padding: 48px 20px;
  text-align: center;
}

.v2-empty-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 56px;
  height: 56px;
  margin: 0 auto 12px;
  color: #f39c12;
  background: #fff7e8;
  border-radius: 16px;
  font-size: 21px;
}

.v2-empty h5 {
  margin: 0 0 6px;
  color: #101828;
  font-size: 15px;
  font-weight: 700;
}

.v2-empty p {
  max-width: 380px;
  margin: 0 auto 16px;
  color: #667085;
  font-size: 12px;
  line-height: 1.6;
}

/* ============================= PAGINASI ============================= */

.v2-table-footer {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 13px 16px;
  background: #ffffff;
  border-top: 1px solid #e9eef6;
}

.v2-footer-left {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  color: #667085;
  font-size: 12px;
}

.v2-select {
  height: 34px;
  padding: 0 26px 0 10px;
  color: #344054;
  background: #ffffff;
  border: 1px solid #e2e8f2;
  border-radius: 8px;
  font-size: 12px;
  cursor: pointer;
}

.v2-select:focus {
  outline: none;
  border-color: #f6c26b;
  box-shadow: 0 0 0 3px rgba(243, 156, 18, 0.14);
}

.v2-footer-divider {
  width: 1px;
  height: 16px;
  background: #e5eaf2;
}

.v2-pager {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 4px;
}

.v2-pager button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-width: 32px;
  height: 32px;
  padding: 0 8px;
  color: #475467;
  background: #ffffff;
  border: 1px solid #e5eaf2;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.18s ease, border-color 0.18s ease,
    color 0.18s ease;
}

.v2-pager button:hover:not(:disabled) {
  color: #b36b00;
  background: #fff7e8;
  border-color: #f6d49b;
}

.v2-pager button.active {
  color: #ffffff;
  background: #f39c12;
  border-color: #f39c12;
}

.v2-pager button:disabled {
  cursor: not-allowed;
  opacity: 0.45;
}

.v2-pager-ellipsis {
  padding: 0 2px;
  color: #98a2b3;
  font-size: 12px;
}

/* ============================= BILAH AKSI MASSAL ============================= */

.v2-bulk-bar {
  position: fixed;
  bottom: 24px;
  left: 50%;
  z-index: 1030;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  max-width: calc(100vw - 32px);
  padding: 10px 12px;
  color: #ffffff;
  background: #0f172a;
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 14px;
  box-shadow: 0 20px 44px rgba(15, 23, 42, 0.3);
  transform: translateX(-50%);
}

.v2-bulk-count {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 6px;
  font-size: 13px;
  font-weight: 600;
  white-space: nowrap;
}

.v2-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 24px;
  height: 24px;
  padding: 0 7px;
  color: #ffffff;
  background: #f39c12;
  border-radius: 20px;
  font-size: 11px;
  font-weight: 700;
}

.v2-bulk-sep {
  width: 1px;
  height: 24px;
  background: rgba(255, 255, 255, 0.14);
}

.v2-bulk-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  height: 34px;
  padding: 0 10px;
  color: #e2e8f0;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 9px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
  cursor: pointer;
  transition: background-color 0.18s ease, color 0.18s ease;
}

.v2-bulk-btn:hover,
.v2-bulk-btn:focus {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.16);
  text-decoration: none;
}

.v2-bulk-delete {
  color: #fecaca;
  background: rgba(239, 68, 68, 0.16);
  border-color: rgba(239, 68, 68, 0.3);
}

.v2-bulk-delete:hover {
  color: #ffffff;
  background: rgba(239, 68, 68, 0.36);
}

.v2-bulk-clear {
  color: #94a3b8;
  background: transparent;
  border-color: transparent;
}

.v2-bulk-clear:hover {
  color: #ffffff;
  background: rgba(255, 255, 255, 0.1);
}

/* ============================= TRANSISI ============================= */

.v2-slide-up-enter-active,
.v2-slide-up-leave-active {
  transition: opacity 0.2s ease, transform 0.2s ease;
}

.v2-slide-up-enter,
.v2-slide-up-leave-to {
  opacity: 0;
  transform: translate(-50%, 14px);
}

/* ============================= RESPONSIF ============================= */

@media (max-width: 991px) {
  .v2-page-head {
    flex-direction: column;
  }

  .v2-head-actions {
    width: 100%;
  }

  .v2-head-actions .v2-btn {
    flex: 1;
  }
}

@media (max-width: 767px) {
  .v2-page {
    padding-top: 18px;
  }

  .v2-title {
    font-size: 22px;
  }

  .v2-stats {
    grid-template-columns: 1fr;
  }

  .v2-search,
  .v2-select-wrap {
    flex: 1 1 100%;
    width: 100%;
  }

  .v2-btn-search,
  .v2-btn-outline {
    flex: 1 1 auto;
  }

  .v2-table-footer {
    justify-content: center;
  }

  .v2-bulk-bar {
    bottom: 14px;
    justify-content: center;
    width: calc(100vw - 24px);
  }

  .v2-bulk-count {
    justify-content: center;
    width: 100%;
  }

  .v2-bulk-sep {
    display: none;
  }

  .v2-bulk-btn {
    flex: 1 1 auto;
  }
}
</style>

<style>
/* Gaya vue-multiselect agar menyatu dengan desain v2.
   Selector dibatasi .contact-v2 agar tidak memengaruhi halaman lain. */
.contact-v2 .v2-select-wrap .multiselect {
  min-height: 40px;
  color: #344054;
  font-size: 13px;
}

.contact-v2 .v2-select-wrap .multiselect__tags {
  min-height: 40px;
  padding: 6px 36px 0 10px;
  background: #ffffff;
  border: 1px solid #e2e8f2;
  border-radius: 10px;
}

.contact-v2 .v2-select-wrap .multiselect__tags:focus-within {
  border-color: #f6c26b;
  box-shadow: 0 0 0 3px rgba(243, 156, 18, 0.14);
}

.contact-v2 .v2-select-wrap .multiselect__placeholder {
  margin-bottom: 4px;
  padding-top: 2px;
  color: #98a2b3;
}

.contact-v2 .v2-select-wrap .multiselect__input,
.contact-v2 .v2-select-wrap .multiselect__single {
  margin-bottom: 4px;
  padding: 0;
  color: #344054;
  font-size: 13px;
  line-height: 20px;
  background: transparent;
}

.contact-v2 .v2-select-wrap .multiselect__tag {
  margin-bottom: 4px;
  color: #b36b00;
  background: #fff7e8;
  border: 1px solid #f6d49b;
  border-radius: 20px;
}

.contact-v2 .v2-select-wrap .multiselect__tag-icon:after {
  color: #b36b00;
}

.contact-v2 .v2-select-wrap .multiselect__tag-icon:hover {
  background: #f39c12;
}

.contact-v2 .v2-select-wrap .multiselect__content-wrapper {
  margin-top: 4px;
  border: 1px solid #e7edf5;
  border-radius: 10px;
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.14);
}

.contact-v2 .v2-select-wrap .multiselect__option--highlight {
  color: #ffffff;
  background: #f39c12;
}

.contact-v2 .v2-select-wrap .multiselect__option--highlight:after {
  color: #ffffff;
  background: #e08e0b;
}

.contact-v2 .v2-select-wrap .multiselect__spinner {
  background: #ffffff;
}

/* Dropdown aksi massal */
.contact-v2 .v2-bulk-group .dropdown-menu {
  min-width: 205px;
  padding: 6px;
  border: 1px solid #e7edf5;
  border-radius: 12px;
  box-shadow: 0 18px 44px rgba(15, 23, 42, 0.2);
}

.contact-v2 .v2-bulk-group .dropdown-item {
  padding: 8px 10px;
  color: #344054;
  border-radius: 8px;
  font-size: 12px;
}

.contact-v2 .v2-bulk-group .dropdown-item:hover,
.contact-v2 .v2-bulk-group .dropdown-item:focus {
  color: #b36b00;
  background: #fffaf1;
}
</style>



// WEBPACK FOOTER //
// src/views/contacts/ContactListV2.vue